import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Listen for toast:show events on window. Turbo's preview/restore caching
    // can leave connect/disconnect unbalanced, so guard against accumulating
    // duplicate window listeners (which would fire the toast multiple times).
    if (this.constructor.activeHandler) {
      window.removeEventListener("toast:show", this.constructor.activeHandler)
    }

    this.handleToastShow = this.handleToastShow.bind(this)
    this.constructor.activeHandler = this.handleToastShow
    window.addEventListener("toast:show", this.handleToastShow)
  }

  disconnect() {
    window.removeEventListener("toast:show", this.handleToastShow)
    if (this.constructor.activeHandler === this.handleToastShow) {
      this.constructor.activeHandler = null
    }
  }

  handleToastShow(event) {
    const { message, type = "info" } = event.detail

    const toast = document.createElement("div")
    toast.setAttribute("data-toast-id", Date.now())

    const colorClasses = {
      success: "bg-success-bg border-success/20 text-success",
      error: "bg-danger-bg border-danger/20 text-danger",
      warning: "bg-warning-bg border-warning/20 text-warning",
      info: "bg-info-bg border-info/20 text-info"
    }

    const icons = {
      success: "check-circle",
      error: "times-circle",
      warning: "triangle-exclamation",
      info: "circle-info"
    }

    const iconStyles = {
      success: "fa-regular",
      error: "fa-regular",
      warning: "fa-solid",
      info: "fa-solid"
    }

    const iconColors = {
      success: "text-success",
      error: "text-danger",
      warning: "text-warning",
      info: "text-info"
    }

    toast.className = `flex items-center gap-3 px-3 py-2 rounded-xl border shadow-lg ${colorClasses[type]} transition-all duration-300 ease-in-out cursor-pointer`

    toast.innerHTML = `
      <div class="flex items-center gap-2">
        <i class="${iconStyles[type]} fa-${icons[type]} ${iconColors[type]}"></i>
        <span class="text-sm font-normal">${message}</span>
      </div>
    `

    // Add click handler to close
    toast.addEventListener("click", () => this.closeToast(toast))

    // Auto-dismiss after 3 seconds
    const timeoutId = setTimeout(() => this.closeToast(toast), 10000)
    toast.dataset.timeoutId = timeoutId

    // Add with slide-in animation
    toast.style.opacity = "0"
    toast.style.transform = "translateX(100%)"
    this.element.appendChild(toast)

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toast.style.opacity = "1"
        toast.style.transform = "translateX(0)"
      })
    })
  }

  closeToast(toast) {
    // Prevent multiple close attempts (race condition)
    if (!toast.parentElement || toast.dataset.closing === "true") return
    toast.dataset.closing = "true"

    // Clear auto-dismiss timeout if exists
    const timeoutId = parseInt(toast.dataset.timeoutId)
    if (timeoutId) clearTimeout(timeoutId)

    // Fade out animation
    toast.style.opacity = "0"
    toast.style.transform = "translateX(100%)"

    // Remove from DOM after animation
    setTimeout(() => {
      if (toast.parentElement) {
        toast.remove()
      }
    }, 10000)
  }
}
